/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CurateIcon = ({ width = 24, height = 24, hidden = false, title = 'Curate' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35 4H1a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-1 26H2v-6h9.663a3.477 3.477 0 0 0 6.674 0h1.326a3.477 3.477 0 0 0 6.674 0H34Zm0-8h-7.663a3.477 3.477 0 0 0-6.674 0h-1.326a3.477 3.477 0 0 0-6.674 0H2v-8h1.663a3.477 3.477 0 0 0 6.674 0h1.326a3.477 3.477 0 0 0 6.674 0h7.326a3.477 3.477 0 0 0 6.674 0H34Zm0-10h-1.663a3.477 3.477 0 0 0-6.674 0h-7.326a3.477 3.477 0 0 0-6.674 0h-1.326a3.477 3.477 0 0 0-6.674 0H2V6h32Z"
    />
  </svg>`;
};
